<template>
  <div class="embarkView">
    <div id="info">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item v-for="(item, index ) in titleList" :key="item">
            <el-button type="text" size="mini" @click="hadleBreadClick(index)" :disabled="index === (titleList.length-1)">{{item}}</el-button>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <label class="boxinfo" id="boxinfo">{{info}}</label>
    </div>
    <div id="slider-panel">
        <div>
            <input id="slider" type="range" min="0" v-model="sliderValue">
            <label>{{sliderValue}}</label>
        </div>
    </div>
    <CarInfo class="carinfo" v-if="currentIndex===1" :data="infoData"/>
    <InsideInfo class="insideInfo" v-if="currentIndex > 1" :data="infoData" :containerName="titleList[titleList.length-1]"/>
  </div>
</template>

<script>
import axios from 'axios';
import CarInfo from './CarInfo';
import InsideInfo from './InsideInfo';
import { Message } from 'element-ui';

export default {
    components: { CarInfo, InsideInfo },
    data () {
        return {
            data: [],
            sliderValue: 0,
            maxValue: 0,
            length: 250,
            width: 250,
            height: 400,
            cubesOnScene: [],
            cubes: [],
            scene: null,
            camera: null,
            renderer: null,
            mouse: null,
            INTERSECTED: null,
            light: null,
            containerEdges: null,
            controls: null,
            raycaster: null,
            info: '',
            doNo: {},
            titleList: ['车辆'],
            searchPrarams: [],
            currentIndex: 1,
            loading: false,
            infoData: {}
        };
    },
    watch: {
        sliderValue: function() {
            this.updateScene();
        }
    },
    mounted() {
        this.doNo = this.$route.query;
        this.initView();
        this.loadData(this.doNo);
    },
    methods: {
        loadData(doNo) {
            let params = doNo;
            axios({
                url: '/embark/load/loadingDiagramsByDoNo',
                method: 'get',
                params: params
            }).then(res => {
                if (res.data) {
                    this.data = res.data.data.vehicleListDtos;
                    this.length = res.data.data.vehicleLength;
                    this.width = res.data.data.vehicleWidth;
                    this.height = res.data.data.vehicleHeight;
                    this.titleList = ['车辆'];
                    this.currentIndex = 1;
                    this.infoData = res.data.data;
                    this.initData();
                }
            });
        },
        loadSubData(index, param) {
            param.trayLists = [];
            axios({
                url: '/embark/load/selectPlotList',
                method: 'post',
                data: param
            }).then(res => {
                if (res.data.data) {
                    this.data = res.data.data.vehicleListDtos;
                    this.length = res.data.data.vehicleLength;
                    this.width = res.data.data.vehicleWidth;
                    this.height = res.data.data.vehicleHeight;
                    this.initData();
                    if (index === this.titleList.length) {
                        this.currentIndex++;
                        this.titleList.push(param.trayName);
                        this.searchPrarams.push(param);
                    } else {
                        this.currentIndex = index + 1;
                        let l = this.titleList.length;
                        this.titleList.splice(index, l - index - 1);
                        this.searchPrarams.splice(index, l - index - 1);
                    }
                }
            });
        },
        initView() {
            var info = document.getElementById('info');
            this.scene = new window.THREE.Scene();
            this.light = new window.THREE.AmbientLight(0xffffff);
            this.camera = new window.THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
            this.camera.position.set(0.3, 0.4, 1.1);
            this.renderer = new window.THREE.WebGLRenderer({ antialias: true, alpha: true });
            this.renderer.setSize(window.innerWidth / 2, window.innerHeight / 2, false);
            this.renderer.setPixelRatio(window.devicePixelRatio);
            info.appendChild(this.renderer.domElement);
            this.controls = new window.THREE.OrbitControls(this.camera, this.renderer.domElement);
            this.mouse = new window.THREE.Vector2(Number.NaN, Number.NaN);
            this.raycaster = new window.THREE.Raycaster();
            window.addEventListener('resize', this.onWindowResize(), false);
            var self = this;
            info.addEventListener('mousemove', function(e) { self.onDocumentMouseMove(e); }, false);
            info.addEventListener('click', function(e) { self.onDocumentMouseClick(e); }, false);
        },
        initData() {
            this.cubes = [];
            this.cubesOnScene = [];
            let n = this.data.length;
            var slider = document.getElementById('slider');
            slider.setAttribute('max', n);
            slider.setAttribute('value', n);
            this.sliderValue = n;
            let L = this.length;
            let W = this.width;
            let H = this.height;
            var max = Math.max(L, W, H);
            L /= max;
            W /= max;
            H /= max;
            var geometry = new window.THREE.BoxGeometry(L, H, W);
            var eGeometry = new window.THREE.EdgesGeometry(geometry);
            var eMaterial = new window.THREE.LineBasicMaterial({
                color: 0x000000,
                transparent: true,
                opacity: 0.3
            });
            this.containerEdges = new window.THREE.LineSegments(eGeometry, eMaterial);
            for (let i = 0; i < n; ++i) {
                var x = this.data[i].vehicleX / max;
                var y = this.data[i].vehicleZ / max;
                var z = this.data[i].vehicleY / max;
                var l = this.data[i].length / max;
                var w = this.data[i].width / max;
                var h = this.data[i].height / max;
                x += l / 2;
                y += h / 2;
                z += w / 2;
                var material = new window.THREE.MeshLambertMaterial({
                    vertexColors: window.THREE.VertexColors,
                    transparent: true,
                    opacity: 0.9
                });
                let geometry = new window.THREE.BoxGeometry(l, h, w);
                let cube = new window.THREE.Mesh(geometry, material);
                let eGeometry = new window.THREE.EdgesGeometry(geometry);
                let eMaterial = new window.THREE.LineBasicMaterial({ color: 0x000000 });
                var edges = new window.THREE.LineSegments(eGeometry, eMaterial);
                cube.add(edges);
                cube.material.color.setRGB(0.35, 0.66, 1);
                cube.position.set(x - L / 2, y - H / 2, z - W / 2);
                var sprite = new window.THREE.TextSprite({
                    textSize: 0.02,
                    material: {
                        color: 0x000000,
                        transparent: true,
                        opacity: 0.8,
                        depthTest: false
                    },
                    texture: {
                        text: '' + this.data[i].trayName
                    }
                });
                cube.userData = this.data[i];
                cube.add(sprite);
                this.cubes.push(cube);
            }
            this.updateScene();
            this.animate();
        },
        updateScene() {
            while (this.scene.children.length > 0) {
                this.scene.remove(this.scene.children[0]);
            }
            this.scene.add(this.light);
            this.scene.add(this.containerEdges);
            this.cubesOnScene = [];
            for (var i = 0; i < this.sliderValue; ++i) {
                this.scene.add(this.cubes[i]);
                this.cubesOnScene.push(this.cubes[i]);
            }
            this.render();
        },
        onWindowResize() {
            this.camera.aspect = window.innerWidth / window.innerHeight;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(window.innerWidth, window.innerHeight);
            this.render();
        },
        onDocumentMouseMove(event) {
            event.preventDefault();
            this.mouse.x = ((event.clientX - 20) / window.innerWidth) * 2 - 1;
            this.mouse.y = -((event.clientY - 20) / window.innerHeight) * 2 + 1;
        },
        onDocumentMouseClick(event) {
            this.mouse.x = ((event.clientX - 20) / window.innerWidth) * 2 - 1;
            this.mouse.y = -((event.clientY - 20) / window.innerHeight) * 2 + 1;
            this.raycaster.setFromCamera(this.mouse, this.camera);
            // 获取raycaster直线和所有模型相交的数组集合
            var intersects = this.raycaster.intersectObjects(this.cubesOnScene);
            if (intersects.length > 0) {
                let data = intersects[0].object.userData;
                if (data.containerCode && data.id) {
                    this.loadSubData(this.currentIndex, data);
                } else {
                    Message.warning('点击了' + data.trayName + '没有子数据');
                }
            }
        },
        animate() {
            requestAnimationFrame(this.animate);
            this.controls.update();
            if (this.mouse !== null) {
                this.raycaster.setFromCamera(this.mouse, this.camera);
                var intersects = this.raycaster.intersectObjects(this.cubesOnScene);
                if (intersects.length > 0) {
                    if (this.INTERSECTED !== intersects[0].object) {
                        if (this.INTERSECTED) this.INTERSECTED.material.emissive.setHex(this.INTERSECTED.currentHex);
                        this.INTERSECTED = intersects[0].object;
                        this.INTERSECTED.currentHex = this.INTERSECTED.material.emissive.getHex();
                        this.INTERSECTED.material.emissive.setHex(0x222222);
                    }
                } else {
                    if (this.INTERSECTED) {
                        this.INTERSECTED.material.emissive.setHex(this.INTERSECTED.currentHex);
                        this.INTERSECTED = null;
                    }
                }
                if (this.INTERSECTED) {
                    let info = {
                        '名称': this.INTERSECTED.userData.trayName,
                        'x坐标': this.INTERSECTED.userData.vehicleX,
                        'y坐标': this.INTERSECTED.userData.vehicleX,
                        'z坐标': this.INTERSECTED.userData.vehicleZ,
                        '长': this.INTERSECTED.userData.length,
                        '宽': this.INTERSECTED.userData.width,
                        '高': this.INTERSECTED.userData.height };
                    this.info = JSON.stringify(info);
                } else {
                    this.info = '';
                }
                this.render();
            }
        },
        render() {
            this.renderer.render(this.scene, this.camera);
        },
        hadleBreadClick(index) {
            if (index === 0) {
                this.loadData(this.doNo);
            } else {
                this.loadSubData(index, this.searchPrarams[index - 1]);
            }
        }
    }
};
</script>

<style lang="less">
    .embarkView{
       #info {
            position: absolute;
            text-align: center;
            top: 0px;
            width: 100%;
            padding: 16px;
            background-color: #eee;
        }

        #slider-panel {
            position: absolute;
            bottom: 0px;
            width: 60%;
            left: 25%;
            padding: 16px;
            text-align: center;
        }

        #slider {
            width: 80%;
        }
        .boxinfo {
            position: absolute;
            top: 110px;
            width: 100%;
            font: 12px;
            color: red;
            text-align: center;
            line-height: 20px;

        }
        .breadcrumb {
            position: absolute;
            top: 50px;
            left: 50px;
        }
        .carInfo {
            background-color: #fff;
            position: absolute;
            top: 20px;
            right: 50px;
        }
        .insideInfo {
            background-color: #fff;
            position: absolute;
            top: 20px;
            right: 50px;
        }
    }
</style>